import React, { useMemo, useCallback } from 'react';
import { IntlProvider } from 'react-intl';
import { Auth0Provider } from '@auth0/auth0-react';

import AppRouter from '../../router';
import * as I18n from '../../i18n';

const App = () => {
    const intl = useMemo(() => {
        const language = navigator.languages?.[0] ?? navigator.language ?? 'en';
        const langCode = language.toLowerCase().split(/[_-]+/)[0];
        const message = I18n.getLanguageInfo(langCode);
        return {
            language,
            messages: message?.url ?? {},
        };
    }, []);

    const onRedirectCallback = useCallback(() => {}, []);

    return (
        <Auth0Provider
            domain={`${process.env.exzeoid_base_url}/oidc`}
            clientId={`${process.env.exzeoid_client_id}`}
            authorizationParams={{
                redirect_uri: `${window.location.origin}`,
                scope: 'openid email profile offline_access',
                allowOfflineAccess: true,
                useRefreshTokens: true,
            }}
            onRedirectCallback={onRedirectCallback}
        >
            <IntlProvider locale={intl.language} messages={intl.messages}>
                <AppRouter />
            </IntlProvider>
        </Auth0Provider>
    );
};

export default App;
